import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import PropTypes from 'prop-types'
import { color, typography } from 'styled-system'

import * as common from '@rushplay/common'
import css from '@styled-system/css'
import styled from '@emotion/styled'
import { useI18n } from '@rushplay/i18n'

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2em;
  height: 2em;
  ${css({
    borderStyle: 'solid',
    borderWidth: '2px',
    borderRadius: '9999px',
    borderColor: 'kewlLinkIconBackground',
    color: 'kewlLinkIconColor',
    bg: 'kewlLinkIconBackground',
    boxShadow: 2,
  })}
${props =>
  props.outlined &&
  css({
    color: 'secondary',
    bg: '#ffffff',
    borderColor: 'secondary',
  })}
${typography}
${color}
`

export function KewlLink(props) {
  const i18n = useI18n()

  return (
    <ReactRouter.Link to={props.to} onClick={props.onClick}>
      <common.Flex alignItems="center">
        <common.Space pr={1}>
          <IconWrapper fontSize={props.fontSize} outlined={props.outlined}>
            <props.icon />
          </IconWrapper>
        </common.Space>
        <common.Text
          color={props.textColor}
          fontWeight="bold"
          fontSize={props.fontSize}
          fontFamily="head"
        >
          {i18n.translate(props.label)}
        </common.Text>
      </common.Flex>
    </ReactRouter.Link>
  )
}

KewlLink.defaultProps = {
  fontSize: [3, 4],
  textColor: 'g-text',
}

KewlLink.propTypes = {
  fontSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  icon: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  outlined: PropTypes.bool,
  onClick: PropTypes.func,
}
